// mocks/react-native-zip-archive-mock.js

// Usamos console.warn para saber cuándo se está usando el mock
console.warn("MOCK: Usando react-native-zip-archive-mock para web.");

// Exporta una función 'unzip' que devuelve una Promesa
// (porque la original devuelve una Promesa) pero sin hacer nada.
export const unzip = (sourcePath, targetPath) => {
  // Opcional: Podrías lanzar un error si alguien intenta usarla.
  // throw new Error("react-native-zip-archive no está implementada en web.");
  
  // O simplemente devolver una promesa resuelta para evitar un bloqueo
  return Promise.resolve(targetPath); 
};

// Si usas otras funciones (como 'zip'), también debes mockearlas
export const zip = () => {
  return Promise.resolve();
};